module.exports = __webpack_public_path__ + "static/media/oioi-logo.238e8695.svg";